import React, { useEffect, useState } from "react";
import Logout from "@mui/icons-material/Logout";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import toast from "react-hot-toast";
import { useNavigate, useLocation } from "react-router-dom";
import Loader from "../Loader";
import moment from "moment";
import axios from "axios";
import TabsComponent from "../FeatureComponents/TabsComponent";
import SearchComponent from "../FeatureComponents/SearchComponent";
import DynamicTable from "../FeatureComponents/DynamicTable";
import Pagination from "../FeatureComponents/Pagination";

function AyekartRetailGrids() {
  const userDetails = JSON.parse(localStorage.getItem("user_detail"));
  const navigate = useNavigate();
  const loc = useLocation();
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [activeTab, setActiveTab] = useState(loc?.state?.activeTab || 0);
  const [tableData, setTableData] = useState([]);
  const [tabData, setTabData] = useState([
    { name: "Pending", count: 0 },
    { name: "Approved", count: 0 },
    { name: "Payment Done", count: 0 },
    { name: "Cancelled", count: 0 },
  ]);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const headersMap = {
    0: [
      { label: "ID", key: "id" },
      { label: "Created At", key: "created_at" },
      { label: "Total Orders", key: "total_orders" },
      { label: "L1 Status", key: "l1_status" },
      { label: "L2 Status", key: "l2_status" },
      { label: "Pending Actioner", key: "pending_actioner",default: "--NA--" },
      { label: "Actioner", key: "actioner" },
    ],
    1: [
      { label: "Grid No", key: "id" },
      { label: "Date", key: "created_at" },
      { label: "Total Orders", key: "total_orders" },
      { label: "Actioner", key: "actioner" },
    ],
    2: [
      { label: "Grid No", key: "id" },
      { label: "Date", key: "created_at" },
      { label: "Total Orders", key: "total_orders" },
      { label: "Actioner", key: "actioner" },
    ],
    3: [
      { label: "Grid No", key: "id" },
      { label: "Date", key: "created_at" },
      { label: "Total Orders", key: "total_orders" },
      { label: "Actioner", key: "actioner" },
    ],
  };

  const handleNavigation = (navigate, id) => {
    const indexInPage = tableData.findIndex((row) => row.id === id);
    const gridPage =
      indexInPage >= 0 ? (page - 1) * limit + indexInPage + 1 : 1;

    navigate("/ayekart-retail/grid-view", {
      state: {
        id,
        activeTab,
        gridPage,
        totalGrids: tabData[activeTab]?.count || 0,
        searchQuery: debouncedSearch || "",
      },
    });
  };

  // Fetch data from API
  const handleSearch = (query) => {
    setPage(1);
    setSearchQuery(query);
  };

  const fetchData = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    const tabNames = ["Pending", "Approved", "Paid", "Rejected"];
    const selectedTab = tabNames[activeTab] || "Pending";
    try {
      const response = await axios.get(
        `/workflow/api/orders/grids?org_id=2&tab_name=${selectedTab}&page=${page}&limit=${10}${
          debouncedSearch ? "&id=" + debouncedSearch : ""
        }`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response?.data?.status) {
        setTableData(response.data.grids || []);
        if (response.data.counts) {
          setTabData((prev) =>
            prev.map((tab, index) => ({
              ...tab,
            }))
          );
        }
      } else {
        setTableData([]);
      }
    } catch (error) {
      setTableData([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchDataCounts = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(
        `/workflow/api/orders/grids_count?org_id=2`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response?.data?.status) {
        setTabData((prevTabs) =>
          prevTabs.map((tab) => {
            let key = tab.name.toLowerCase();
            if (key === "payment done") key = "paid";
            if (key === "cancelled") key = "rejected";
            return {
              ...tab,
              count: response.data.counts[key] || 0,
            };
          })
        );
      } else {
        console.error("Failed to fetch tab counts.");
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [activeTab, page, debouncedSearch]);

  // ==============================================

  const handleTabChange = (event, newValue) => {
    setPage(1);
    setActiveTab(newValue);
  };

  useEffect(() => {
    if (userDetails?.user_category !== "Operations") {
      toast.error("Access denied");
      return navigate("/");
    }
    fetchDataCounts();
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 600);

    return () => clearTimeout(handler);
  }, [searchQuery]);

  return (
    <div className="container-fluid mt-4">
      <Loader loading={loading} />
      <button
        className="btn"
        onClick={() => navigate(`/ayekart-retail/orders`)}
      >
        <span className="text-primary">{`<< Back`}</span>
      </button>
      <div className="container-fluid border rounded-3 p-3 bg-light">
        <div className="py-2 px-3 flex justify-between items-center">
          <TabsComponent
            tabData={tabData}
            activeTab={activeTab}
            onTabChange={handleTabChange}
          />
          {/* Search bar */}
          <div className="max-w-[200px]">
            <SearchComponent onSearch={handleSearch} />
          </div>
        </div>

        <DynamicTable
          headers={headersMap[activeTab]}
          data={tableData}
          action={handleNavigation}
        />

        <div className="flex justify-start pl-2">
          <Pagination
            page={page}
            limit={limit}
            totalRecords={tabData[activeTab]?.count || 1}
            onPageChange={(newPage) => setPage(newPage)}
          />
        </div>
      </div>
    </div>
  );
}

export default AyekartRetailGrids;
